import React from "react";
import { Button, CardActions, FontIcon } from "react-md";
import { Field, reduxForm } from "redux-form";
import capitalize from "lodash/capitalize";
import ReactMDTextField from "../../../common/components/ReactMDTextField";
import { required, email, phone } from "../../../common/validators";
import { normalizeEmail } from "../../../common/normalize";

const ContactInfoForm = ({ handleSubmit, invalid, submitting }) => (
  <div>
    <section className="md-grid">
      <Field
        validate={[required]}
        id="firstName"
        name="firstName"
        component={ReactMDTextField}
        label="First Name"
        leftIcon={<FontIcon>face</FontIcon>}
        className="md-cell md-cell--6"
        required
        format={(value, name) => capitalize(value)}
      />
      <Field
        validate={[required]}
        id="lastName"
        name="lastName"
        component={ReactMDTextField}
        label="Last Name"
        className="md-cell md-cell--6"
        required
        format={(value, name) => capitalize(value)}
      />
      <Field
        validate={[required, email]}
        normalize={normalizeEmail}
        id="email"
        name="email"
        type="email"
        component={ReactMDTextField}
        label="Email Address"
        helpText="Next time, when you enter this email address your registration will pre-fill with today's answers."
        className="md-cell md-cell--12"
        pattern="^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$"
        required
        leftIcon={<FontIcon>email</FontIcon>}
      />

      <Field
        validate={[required, phone]}
        normalize={(value) => (value ? value.replace(/\D/g, "") : value)}
        id="phone"
        name="phone"
        type="tel"
        component={ReactMDTextField}
        label="Phone Number"
        helpText="10-digit US phone number, no need for +1."
        className="md-cell md-cell--12"
        required
        leftIcon={<FontIcon>phone</FontIcon>}
      />
    </section>
    <CardActions>
      <Button
        raised
        label="Save & Continue"
        primary
        className="md-cell--right"
        disabled={submitting || invalid}
        onClick={handleSubmit}
      />
    </CardActions>
  </div>
);

ContactInfoForm.propTypes = {};
ContactInfoForm.defaultProps = {};

export default reduxForm({
  form: "contact-info"
})(ContactInfoForm);



// WEBPACK FOOTER //
// ./src/registration/components/ContactInfo/ContactInfoForm.jsx